<div class="organization-modal modal-content" piqetAngularDraggable>
  <div class="modal-header">
    <span class="bootstrap-dialog-title">{{ modalLabel }} </span>

    <button type="button" class="closeModal pull-right" aria-label="Close" (click)="onClose()">
      <img src="./assets/icons/pop-up-cross.svg" width="16" height="17" />
    </button>
  </div>

  <div class="modal-body body-modal">
    <form [formGroup]="circularEconomyParameterAddEditForm">
      <div class="row">
        <div class="col-sm-6">
          <div class="form-group required">
            <label
              *ngIf="
                circularEconomyParameterAddEditForm.get('material')?.value ||
                circularEconomyParameterAddEditForm.get('organizationName')?.value
              "
              class="sub-header-drpdown pb-2"
              >Material</label
            >
            <ng-select
              [clearable]="true"
              [clearOnBackspace]="false"
              class="accordion-text addScroll"
              [virtualScroll]="true"
              #select
              [items]="materialList"
              [searchable]="false"
              formControlName="material"
              bindLabel="description"
              [readonly]="isDisableDropDown"
              [searchFn]="commonInputSearchForMaterial"
              placeholder="Material *"
              bindValue="id"
              groupBy="childItems"
            >
              <ng-template ng-header-tmp>
                <div class="has-feedback">
                  <input
                    type="text"
                    class="accordion-search form-control search-input"
                    id="inputValidation"
                    (input)="select.filter($any($event.target).value)"
                    placeholder="Search..."
                  />
                  <span class="form-control-feedback">
                    <i class="fa fa-search icon"></i>
                  </span>
                </div>
              </ng-template>
              <ng-template ng-optgroup-tmp let-item="item" let-search="searchTerm">
                <div [ngOptionHighlight]="search" title="{{ item?.description }}">
                  {{ item?.description }}
                </div>
              </ng-template>
              <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
                <div [ngOptionHighlight]="search" title="{{ item?.description }}">
                  {{ item?.description }}
                </div>
              </ng-template>
            </ng-select>
            <div
              *ngIf="submitted || circularEconomyParameterAddEditForm.controls['material']?.touched"
              class="input-error"
            >
              <div *ngIf="circularEconomyParameterAddEditForm.controls['material']?.invalid">
                Material is required.
              </div>
            </div>
          </div>
        </div>
        <div class="col-sm-6">
          <div class="form-group required">
            <label
              *ngIf="
                circularEconomyParameterAddEditForm.get('material')?.value ||
                circularEconomyParameterAddEditForm.get('organizationName')?.value
              "
              class="sub-header-drpdown pb-2"
              >Organization</label
            >
            <ng-select
              [clearable]="true"
              [clearOnBackspace]="false"
              #organization
              [items]="organizationlist"
              [searchable]="false"
              bindLabel="name"
              formControlName="organizationName"
              [searchFn]="commonInputSearch"
              placeholder="All organization"
            >
              <ng-template ng-header-tmp>
                <div class="has-feedback">
                  <input
                    type="text"
                    class="form-control accordion-search search-input"
                    id="inputValidation"
                    (input)="organization.filter($any($event.target).value)"
                    placeholder="Search..."
                  />
                  <span class="form-control-feedback">
                    <i class="fa fa-search icon"></i>
                  </span>
                </div>
              </ng-template>
              <ng-template ng-optgroup-tmp let-item="item" let-search="searchTerm">
                <div [ngOptionHighlight]="search" title="{{ item?.name }}">{{ item?.name }}</div>
              </ng-template>
              <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
                <div [ngOptionHighlight]="search" title="{{ item?.name }}">{{ item.name }}</div>
              </ng-template>
            </ng-select>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-6">
          <div class="form-group required" aria-required="true">
            <div class="services-form">
              <input
                formControlName="EC_EfficiencyRecyclingEOL"
                type="number"
                maxlength="30"
                oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
                placeholder="EC_Efficiency Recycling EOL"
              />
              <label>EC_efficiency recycling EOL</label>
              <div
                *ngIf="
                  (submitted ||
                    circularEconomyParameterAddEditForm.controls['EC_EfficiencyRecyclingEOL']
                      .touched) &&
                  circularEconomyParameterAddEditForm.controls['EC_EfficiencyRecyclingEOL'].errors
                "
              >
                <div
                  *ngIf="circularEconomyParameterAddEditForm.controls['EC_EfficiencyRecyclingEOL'].errors?.['required']"
                  class="input-error"
                >
                  EC_efficiency recycling EOL is required.
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-sm-6">
          <div class="form-group required" aria-required="true">
            <div class="services-form">
              <input
                formControlName="EF_EfficiencyOfRecyclingForInputMaterial"
                type="number"
                maxlength="30"
                oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
                placeholder="EF_efficiency of recycling for input material"
              />
              <label>EF_efficiency of recycling for input material</label>
              <div
                *ngIf="
                  (submitted ||
                    circularEconomyParameterAddEditForm.controls[
                      'EF_EfficiencyOfRecyclingForInputMaterial'
                    ].touched) &&
                  circularEconomyParameterAddEditForm.controls[
                    'EF_EfficiencyOfRecyclingForInputMaterial'
                  ].errors
                "
              >
                <div
                  *ngIf="circularEconomyParameterAddEditForm.controls['EF_EfficiencyOfRecyclingForInputMaterial'].errors?.['required']"
                  class="input-error"
                >
                  EF_efficiency of recycling for input material is required.
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
  <div class="modal-footer text-margin">
    <button type="button" class="cancelBtn" (click)="onClose()">Cancel</button>
    <button type="button" class="modelBtn purpleBtnHoverEffect" (click)="onSave()">Save</button>
  </div>
</div>
